
function Lightning() {
	return (
		<svg height="48" width="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
			<g>
				<path
					d="M19.99951,45c-0.16113,0-0.32373-0.03906-0.47314-0.11914c-0.40283-0.2168-0.60742-0.67969-0.49658-1.12354 L22.71924,29H6c-0.39648,0-0.75586-0.23438-0.91553-0.59717C4.9248,28.03955,4.99512,27.6167,5.2627,27.32422l22-24 c0.30957-0.3374,0.80811-0.42188,1.21094-0.20508s0.60742,0.67969,0.49658,1.12354L25.28076,19H42 c0.39648,0,0.75586,0.23438,0.91553,0.59717c0.15967,0.36328,0.08936,0.78613-0.17822,1.07861l-22,24 C20.54248,44.8877,20.27295,45,19.99951,45z"
					fill="#EFD358"
				/>
			</g>
		</svg>
	);
}

export default Lightning;
